import React, {Component} from 'react';
import axios from "../../../axios-cmk";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import {connect} from "react-redux";
import {Col, Container, Row, Table} from "reactstrap";
import {loadPatientsReportData} from "../../../store/actions";
import FontAwesome from 'react-fontawesome';
import '../Reports.css'

class TherapistsReport extends Component {

    state = {
        therapistFilter: ''
    };

    onTherapistFilterChange = (event) => {
        this.setState({
            therapistFilter: event.target.value
        })
    }

    render() {
        const data_rows = this.props.report_data.therapists.filter((stat) => {
            if (this.state.patientFilter !== '') {
                if (stat.therapist.label.toLowerCase().indexOf(this.state.therapistFilter.toLowerCase()) >= 0) {
                    return stat
                }
            } else {
                return stat
            }
            return null
        }).map((stat, index) => {
            return (
                <tr key={stat.therapist.id}>
                    <th>{index + 1}</th>
                    <td>{stat.therapist.label}</td>
                    <td className="text-center dataColumn" sm={1}>{stat.plan_hours}h</td>
                    <td className="text-center dataColumn" sm={1}>{stat.visit_hours}h</td>
                    <td className="text-center dataColumn" sm={1}>{stat.canceled_paid}h</td>
                    <td className="text-center dataColumn" sm={1}>{stat.canceled_free}h</td>
                </tr>
            )
        });

        return (
            <Container fluid>
                <Row>
                    <Col>
                        <Table striped>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Terapeuta</th>
                                <th className="text-center" sm={1}>Zaplanowane</th>
                                <th className="text-center" sm={1}>Odbyte</th>
                                <th className="text-center" sm={1}>Anulacja płatna</th>
                                <th className="text-center" sm={1}>Anulacja darmowa</th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><FontAwesome
                                                name='filter'/></span>
                                        </div>
                                        <input type="text" className="form-control" placeholder="Filtruj terapetów"
                                               aria-describedby="basic-addon1" onChange={this.onTherapistFilterChange}/>
                                    </div>
                                </th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {data_rows}
                            </tbody>
                        </Table>
                    </Col>
                </Row>

            </Container>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadData: (period) => dispatch(loadPatientsReportData(period)),
    }
}

const mapStateToProps = state => {
    return {
        reports_period: state.reports.reports_period,
        report_data: state.reports.patients_report_data
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(TherapistsReport, axios));


// WEBPACK FOOTER //
// ./src/components/Reports/Therapists/TherapistsReport.js